module.exports = __webpack_public_path__ + "static/media/logo.48c145b1.png";